"use strict";const amplitude=require("amplitude-js");var main={install:(e,{apiKey:t,userId:i,config:a})=>{amplitude.getInstance().init(t,i,a),e.prototype.$amplitude=amplitude}};module.exports=main;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-amplitude/dist/vue-amplitude.js
// module id = rG3U
// module chunks = 1